export default __webpack_public_path__ + "static/media/icon-ic-address-book-menu.9c570bcf.svg";